import Whisper from "rsuite/Whisper";
import Tooltip from "rsuite/Tooltip";


const SetAmountDeposit = ({ amountDeposit, setAmountDeposit, methodPayment, accrualAmount }) => {

    function formatAccrualAmount(num) {
        return num >= 100 ? num.toFixed(0) : num.toFixed(2);
    }

    return (
        <div className="modal-payment d-flex">
            <div className="amountDeposit-wrapper">
                <input value={amountDeposit} onChange={(e) => setAmountDeposit(!Number(e.target.value) ? "" : +e.target.value)} className="modal-payment-input" type="number"/>
                <span>{ methodPayment?.currency }</span>
            </div>
            <div className="icon-payment">
                <svg width="24" height="22" viewBox="0 0 24 24" fill="#8595ae">
                    <path
                        d="M15.429 10.073v-4.48c0-.379-.356-.687-.794-.687h-6.95V2.689c0-.607-.845-.917-1.347-.493L.24 7.34a.626.626 0 000 .985l6.098 5.145c.502.423 1.348.115 1.348-.493V10.76h6.949c.438 0 .794-.308.794-.688zm8.331 5.601l-6.098-5.145c-.502-.423-1.348-.115-1.348.493v2.217H9.365c-.438 0-.794.308-.794.688v4.48c0 .38.356.688.794.688h6.95v2.217c0 .609.848.914 1.347.493l6.098-5.145a.626.626 0 000-.986z"></path>
                </svg>
            </div>
            <Whisper
                placement={"top"}
                speaker={
                    <Tooltip style={{zIndex: "99999", textAlign: "center"}}>Це ваш бонус, який буде додано до поповненої суми!</Tooltip>
                }>
                <div className="display-bonus">
                    { accrualAmount === "" ? "" : "Бонус" }
                    <span>+ {formatAccrualAmount(accrualAmount)}</span>
                </div>
                <span className="svg-bonus-icon">
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M11.1112 12.231V6.90736H9.61458C7.95721 6.90736 7.08331 5.83258 7.08331 4.78794C7.08331 3.7031 7.88693 3.06024 8.9617 3.06024C10.1972 3.06024 11.1615 4.0145 11.1615 5.61157V6.90736H12.8389V5.61157C12.8389 4.0145 13.8032 3.06024 15.0387 3.06024C16.1135 3.06024 16.9271 3.7031 16.9271 4.78794C16.9271 5.83258 16.0231 6.90736 14.3858 6.90736H12.8891V12.231H19.9706C21.0655 12.231 21.6582 11.8091 21.6582 10.7343V8.40401C21.6582 7.33927 21.0655 6.90736 19.9706 6.90736H17.6302C18.253 6.34486 18.6247 5.58144 18.6247 4.71761C18.6247 2.77901 17.0878 1.38281 15.1391 1.38281C13.6927 1.38281 12.5175 2.18634 12.0052 3.61271C11.4929 2.18634 10.3077 1.38281 8.86124 1.38281C6.92264 1.38281 5.37576 2.77901 5.37576 4.71761C5.37576 5.58144 5.73734 6.34486 6.37017 6.90736H4.02979C2.99517 6.90736 2.34229 7.33927 2.34229 8.40401V10.7343C2.34229 11.8091 2.94494 12.231 4.02979 12.231H11.1112ZM11.1112 22.6172V13.3058H3.77864V20.0658C3.77864 21.7433 4.76303 22.6172 6.44046 22.6172H11.1112ZM12.8891 13.3058V22.6172H17.5599C19.2373 22.6172 20.2217 21.7433 20.2217 20.0658V13.3058H12.8891Z" fill="var(--deposit-modal-color)"></path></svg>
                </span>
            </Whisper>
        </div>
    );
};

export default SetAmountDeposit;